import { ConfigurableForm, ConfigurablePage } from 'configurable-form/';
import { ConfigurableUploadForm } from 'configurable-form/configurable-upload-form';

export const confPageComponents = {
  ConfigurableForm,
  ConfigurableUploadForm,
  ConfigurablePage,
};
